module.exports = "<app-header></app-header>\n<app-message-banner [messages]=\"messages\" ></app-message-banner>\n<router-outlet></router-outlet>\n"